import { UpdatePrompt } from '@/components/updatePrompt/UpdatePrompt.jsx';

import { Suspense } from 'react';
import { Toaster } from 'sonner';
import { Pages } from '@/pages/Pages.jsx';
import 'animate.css';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/counter.css';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import isBetween from 'dayjs/plugin/isBetween.js';
import timezone from 'dayjs/plugin/timezone.js';
import { HeroUIProvider } from '@heroui/react';
import { ModalProvider } from 'react-modal-hook';
import VerdantProvider from './components/VerdantProvider.jsx';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);

// biome-ignore lint/complexity/noBannedTypes: <explanation>
export type AppProps = {};

export function App(props: AppProps) {
  return (
    <ModalProvider>
      <Suspense>
        <VerdantProvider>
          <HeroUIProvider>
            <Toaster
              position='top-center'
              richColors
              style={{
                top: 'calc(env(safe-area-inset-top) + 36px)',
              }}
            />

            <Pages />

            <UpdatePrompt />
          </HeroUIProvider>
        </VerdantProvider>
      </Suspense>
    </ModalProvider>
  );
}
